import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { EGDSLayoutGrid } from '@egds/react-core/layout-grid';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { ExperienceTemplateRenderer } from 'experience-template-renderer-react';
import { any, boolean, number, object, optional, safeParse } from 'valibot';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
export const ResultsWrapper = inject('multiItem')(observer(({
  templateComponent,
  multiItem
}) => {
  var _a;
  const {
    children,
    config
  } = templateComponent;
  const isPackageShoppingPath = multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath();
  const configSchema = optional(object({
    columns: number(),
    space: any(),
    bexQuickFiltersEnabled: optional(boolean())
  }));
  const result = safeParse(configSchema, config);
  if (!result.success || !children || children.length === 0) {
    return null;
  }
  const {
    columns,
    space,
    bexQuickFiltersEnabled
  } = (_a = result.output) !== null && _a !== void 0 ? _a : {};
  return React.createElement(EGDSSpacing, {
    padding: bexQuickFiltersEnabled ? {
      blockstart: 'two'
    } : {
      small: {
        block: isPackageShoppingPath ? 'unset' : 'three'
      },
      medium: {
        blockstart: 'one'
      },
      large: {
        blockstart: 'three'
      }
    }
  }, React.createElement("div", {
    className: "search-results-listing"
  }, React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(EGDSLayoutGrid, {
    columns: columns,
    space: space
  }, children && React.createElement(ExperienceTemplateRenderer, {
    templateComponents: children
  }))), React.createElement(ViewSmall, null, React.createElement(EGDSLayoutGrid, {
    columns: 1
  }, children && React.createElement(ExperienceTemplateRenderer, {
    templateComponents: children
  }))))));
}));